// @flow
import { connect } from 'react-redux';

import TeamCalendar, { type StateProps } from 'components/team/TeamCalendar';

import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  title: state.pageListState.title,
  nextMatches: state.teamCalendarState.nextMatches,
  status: state.teamCalendarState.status,
  competitions: state.teamResultState.competitions,
  competitions_ovale: state.pageListState.competitions,
  clubName: state.settingsState.title,
  rejoignez_nous: state.settingsState.rejoignez_nous,
  rejoignez_nous_background: state.settingsState.rejoignez_nous_background,
  historique: state.pageListState.competitions_saisons,
  currentSeason: state.seasonsState.lastSeason,
});

export default connect(mapStateToProps, null)(TeamCalendar);
